<template>
  <div class="beneficios-items-container">
    <g-master
      name="beneficios-items"
      :endpoint="masterConfig.endpoint"
      :tableSetup="masterConfig.tableSetup"
      :modalFieldsSetup="masterConfig.modalFieldsSetup"
      :parentData="parentData"
      :useMultipart="true"
      :beforeSend="beforeSendData"
      @action="handleMasterAction"
      modalWidth="70%"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Titulo">
              <a-input
                v-decorator="['att_car1', { rules: [{ required: true, message: 'El titulo es requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Subtitulo">
              <a-input
                v-decorator="['att_car2', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Descripción">
              <a-textarea
                :rows="4"
                v-decorator="['description', { rules: [{ required: true, message: 'La descripcion es requerido' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Url">
              <a-input
                v-decorator="['url', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Estado">
              <a-select
                v-decorator="['status', { rules: [{ required: false, message: 'El estado es requerido' }] }]"
              >
                <a-select-option value="ACTIVO">ACTIVO</a-select-option>
                <a-select-option value="INACTIVO">INACTIVO</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Atributo Numérico 1">
              <a-input-number
                style="width: 100%"
                v-decorator="['att_num1', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Atributo Numérico 2">
              <a-input-number
                style="width: 100%"
                v-decorator="['att_num2', { rules: [{ required: false }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Fecha 1">
              <a-date-picker
                style="width: 100%"
                v-decorator="['att_date1', { rules: [{ required: false }] }]"
                format="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Fecha 2">
              <a-date-picker
                style="width: 100%"
                v-decorator="['att_date2', { rules: [{ required: false }] }]"
                format="YYYY-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" label="Logo">
              <a-upload
                :before-upload="handleBeforeUploadLogo"
                :file-list="fileListLogo"
                @remove="handleRemoveLogo"
                accept="image/*"
                list-type="picture"
              >
                <a-button>
                  <a-icon type="upload" /> Seleccionar imagen
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
      <span slot="estadoRenderer" slot-scope="{text}">
        <a-tag :color="text === 'ACTIVO' ? 'green' : 'red'">
          {{ text }}
        </a-tag>
      </span>
    </g-master>
  </div>
</template>

<script>
  export default {
    name: 'BeneficiosItems',
    props: {
      benefitId: {
        type: [Number, String],
        required: true
      }
    },
    data () {
      return {
        fileListLogo: [],
        logoUploads: [],
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        masterConfig: {
          endpoint: 'benefits_cat_detail',
          tableSetup: {
            customSlots: ['estadoRenderer'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID', dataIndex: 'id', sorter: true, width: 80},
              {title: 'Titulo', dataIndex: 'att_car1', sorter: true},
              {title: 'Subtitulo', dataIndex: 'att_car2', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Valor Num. 1', dataIndex: 'att_num1', sorter: true, width: 120},
              {title: 'Valor Num. 2', dataIndex: 'att_num2', sorter: true, width: 120},
              {title: 'Fecha 1', dataIndex: 'att_date1', sorter: true, width: 120},
              {title: 'Fecha 2', dataIndex: 'att_date2', sorter: true, width: 120},
              {title: 'Url', dataIndex: 'url', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status',
                sorter: true,
                width: 110,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'logo_path'},
            {name: 'logo_name'},
            {name: 'att_car1'},
            {name: 'att_car2'},
            {name: 'att_num1'},
            {name: 'att_num2'},
            {name: 'att_date1', type: 'date'},
            {name: 'att_date2', type: 'date'},
            {name: 'status'},
            {name: 'url'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_benefits: this.benefitId
        }
      }
    },
    methods: {
      handleMasterAction (action) {
        if (action.action === 'handleOkResp') {
          this.logoUploads = []
          this.fileListLogo = []
        }
        if (action.action === 'masterCreate') {
          this.logoUploads = []
          this.fileListLogo = []
        }
        if (action.action === 'masterEdit') {
          this.logoUploads = []
          this.fileListLogo = []
        }
      },
      /**
       * Validates logo file before upload
       * @param {File} file - The file selected for upload
       * @returns {boolean} Always returns false to prevent auto-upload
       */
      handleBeforeUploadLogo (file) {
        const isImage = file.type.startsWith('image/')
        if (!isImage) {
          this.$message.error('Solo se pueden subir archivos de imagen')
          return false
        }
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('La imagen debe ser menor a 5MB')
          return false
        }

        this.logoUploads = [file]
        this.fileListLogo = [file]

        return false
      },
      handleRemoveLogo () {
        this.logoUploads = []
        this.fileListLogo = []
      },
      /**
       * Prepares form data before sending to backend
       * Adds the logo file if present
       * @param {Object} formData - Form data object
       * @returns {Object} Processed form data
       */
      beforeSendData (formData) {
        if (this.logoUploads.length > 0) {
          formData.logo = this.logoUploads[0]
        }
        return formData
      }
    }
  }
</script>

<style scoped>
  .beneficios-items-container {
    padding: 0;
  }
</style>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BeneficiosItems.vue